<template>
  <div class="offer__container--block">
    <button
      :class="{
        'button__is-clicked': button.main && returnColor === '',
        offer__button: returnColor === '',
        'button__is-clicked--bordo': button.main && returnColor === '#801C62',
        'offer__button--bordo': returnColor === '#801C62',
        'button__is-clicked--red': button.main && returnColor === '#c9012c',
        'offer__button--red': returnColor === '#c9012c',
        'button__is-clicked--yellow': button.main && returnColor === '#FFBC14',
        'offer__button--yellow': returnColor === '#FFBC14', 
      }"
      v-for="(button, index) in buttons"
      :key="index"
      ref="buttonComponent"
      @click="changeMainOffer(button)"
      @mouseover="showVinNumber(button.vin)"
      @mouseleave="hideVinNumber"
      @touchstart.passive="showVinNumber(button.vin)"
      @touchend="hideVinNumber"
    >
      <div
        class="offer__button--check"
        :class="{ 'box__is-clicked': button.isShown }"
        @click.stop="matchButton(button, index)"
      >
        <svg
          class="offer__check--icon"
          :class="{ 'is-hidden-icon': !button.isShown }"
          width="18"
          height="14"
        >
          <image :href="iconCheckUrl" width="18" height="14"></image>
        </svg>
      </div>
      <div class="offer__block">
        <p class="offer__button--description">
          {{ button.make }} {{ button.model }}
        </p>
        <small v-if="showVin === button.vin">VIN: {{ button.vin }}</small>
      </div>
      <svg class="offer__icon">
        <image class="offer__icon--image" :href="iconArrowUrl"></image>
      </svg>
    </button>
    <button
      :class="{
        offer__button: file.main && returnColor === '',
        'offer__button--bordo': returnColor === '#801C62',
        'button__is-clicked--bordo': file.main && returnColor === '#801C62',
        'offer__button--bordo': returnColor === '#801C62',
        'button__is-clicked--red': file.main && returnColor === '#c9012c',
        'offer__button--red': returnColor === '#c9012c',
      }"
      v-for="(file, indexFile) in additionalFiles"
      :key="indexFile"
      @click="changeMainAdditionalFile(file)"
    >
      <div class="offer__block">
        <p class="offer__button--description">{{ file.brand_model_name }}</p>
      </div>
      <svg class="offer__icon">
        <image class="offer__icon--image" :href="iconArrowUrl"></image>
      </svg>
    </button>
  </div>
</template>

<script>
import dataToCompare from "../../plugins/dataToCompare";
import { useStore } from "../../store.js";
import httpActions from "../../plugins/httpActionService";

export default {
  props: {
    clearData: Boolean,
  },
  computed: {
    iconCheckUrl() {
      return '/Icons/check.svg';
    },
    iconArrowUrl() {
      return '/Icons/arrow_left_test.png';
    },
    mainOffer() {
      return useStore().getMainOffer;
    },
    dataChange() {
      return useStore().data;
    },
    returnColor() {
      return useStore().getColor;
    },
    mainAdditionalFile() {
      return useStore().mainAdditionalFile[0];
    },
  },
  data() {
    return {
      isAnyButtonClicked: false,
      buttons: [],
      clickedButtonsCount: 0,
      additionalFiles: [],
      showVin: null,
    };
  },
  methods: {
    showVinNumber(vin) {
      this.showVin = vin;
    },
    hideVinNumber() {
      this.showVin = null;
    },
    matchButton(button, index) {
      if (localStorage.getItem("dataToCompare")) {
        dataToCompare.data = JSON.parse(
          localStorage.getItem("dataToCompare")
        );
      } else {
        dataToCompare.data = [];
      }

      button.isShown = !button.isShown;
      useStore().updateIndex(index);

      const localStorageData = JSON.parse(
        localStorage.getItem("dataToCompare")
      );

      if (button.isShown) {
        dataToCompare.data.push(button);
        localStorage.setItem(
          "dataToCompare",
          JSON.stringify(dataToCompare.data)
        );
        this.clickedButtonsCount++;
      } else {
        const foundIndex = localStorageData.findIndex(
          (item) =>
            item.make === button.make &&
            item.model === button.model &&
            item.id === button.id
        );
        if (foundIndex !== -1) {
          localStorageData.splice(foundIndex, 1);
          localStorage.setItem(
            "dataToCompare",
            JSON.stringify(localStorageData)
          );
        }
        this.clickedButtonsCount--;
      }
      this.isAnyButtonClicked = this.buttons.some((button) => button.isShown);
      useStore().set("compareButtonClicked", this.isAnyButtonClicked);
      useStore().set("clickedButtonsCount", this.clickedButtonsCount);
    },

    getData() {
      if (useStore().data) {
        this.buttons = useStore().data.vehicles;
        if (useStore().data.additionalVehicleFiles) {
          this.additionalFiles = useStore().data.additionalVehicleFiles;
        }

        const localStorageData = JSON.parse(
          localStorage.getItem("dataToCompare")
        );
        if (localStorageData) {
          this.buttons.forEach((button) => {
            const found = localStorageData.find(
              (item) =>
                item.make === button.make &&
                item.model === button.model &&
                item.id === button.id
            );
            if (found) {
              button.isShown = true;
              this.clickedButtonsCount++;
            }
          });
          this.isAnyButtonClicked = this.clickedButtonsCount > 0;
        } else {
          this.buttons = useStore().data.vehicles;
        }
      }
    },
    changeMainOffer(button) {
      useStore().addMainOffer(button);
      useStore().addMainAdditionalFile([]);
      useStore().set("filesButtonClicked", false);
      this.$emit("closeMobileMenu", true);
      if (this.$route.path === "/compare") {
        this.$router.push("/main");
      }
    },
    changeMainAdditionalFile(file) {
      useStore().addMainAdditionalFile(file);
      this.$emit("closeMobileMenu", true);
      httpActions.trackFiles("jd028g", file.id, useStore().defaultOfferID);
      useStore().addMainOffer([]);
      useStore().set("filesButtonClicked", false);
      if (this.$route.path === "/compare") {
        this.$router.push("/main");
      }
    },
    checkActiveOffer() {
      if (useStore().mainOffer[0]?.make) {
        const mainOffer = useStore().mainOffer[0];

        this.buttons.forEach((button) => {
          if (
            button.make === mainOffer.make &&
            button.model === mainOffer.model &&
            button.id === mainOffer.id
          ) {
            button.main = true;
          }
        });
      } else if (this.mainAdditionalFile && !useStore().mainOffer[0]?.make) {
        const mainAdditionalFile = this.mainAdditionalFile;
        this.additionalFiles.forEach((file) => {
          if (
            file.url === mainAdditionalFile.url &&
            file.brand_model_name === mainAdditionalFile.brand_model_name
          ) {
            file.main = true;
          }
        });
      }
    },
  },
  mounted() {
    this.getData();
    this.checkActiveOffer();
    if (
      this.$route.path === "/compare" &&
      !useStore().updateChangeOfferFromCompare
    ) {
      useStore().set("compareButtonClicked", false);
      useStore().set("clickedButtonsCount", 0);
      this.clickedButtonsCount = 0;
      this.buttons.forEach((button) => {
        button.isShown = false;
      });
      setTimeout(() => {
        useStore().set("disableAddMainOffer", true);
      }, 1000);
    }
  },
  watch: {
    mainOffer(newVal) {
      if (newVal) {
        this.buttons.forEach((button) => {
          button.main = false;
        });
        this.checkActiveOffer();
      }
    },
    mainAdditionalFile(newVal) {
      if (newVal) {
        this.additionalFiles.forEach((file) => {
          file.main = false;
        });
        this.checkActiveOffer();
      }
    },
    dataChange(newVal) {
      if (newVal) {
        this.getData();
      }
    },
    clearData(newVal) {
      if (newVal) {
        useStore().set("compareButtonClicked", false);
        useStore().set("clickedButtonsCount", 0);
        this.clickedButtonsCount = 0;
        this.buttons.forEach((button) => {
          button.isShown = false;
        });
      }
    },
  },
};
</script>